import { FC } from "react"
import { IconProps } from "@/components/shared/Icon"

const FlagIcon: FC<IconProps> = ({ ...props }) => {
   return (
      <svg
         viewBox="0 0 24 24"
         fill="none"
         {...props}
      >
         <path
            d="M4.92857 2.67864C4.92857 2.14427 4.49866 1.71436 3.96429 1.71436C3.42991 1.71436 3 2.14427 3 2.67864V4.28578V15.7969V17.7858V21.3215C3 21.8559 3.42991 22.2858 3.96429 22.2858C4.49866 22.2858 4.92857 21.8559 4.92857 21.3215V17.3036L8.15491 16.4961C9.80625 16.0822 11.554 16.2751 13.0768 17.0344C14.8527 17.9224 16.9138 18.0309 18.7701 17.3318L20.1643 16.8094C20.6665 16.6206 21 16.1425 21 15.6041V4.37016C21 3.44605 20.0277 2.84337 19.2 3.25721L18.8143 3.45007C16.954 4.38221 14.7643 4.38221 12.904 3.45007C11.4937 2.74293 9.87455 2.56614 8.34375 2.94784L4.92857 3.80364V2.67864ZM4.92857 5.79248L8.80982 4.82016C9.89464 4.55096 11.0397 4.67552 12.0402 5.17373C14.246 6.27462 16.8094 6.36703 19.0714 5.44695V15.1621L18.0911 15.5277C16.7371 16.034 15.2304 15.9577 13.9366 15.3108C12 14.3425 9.78616 14.1014 7.68482 14.6237L4.92857 15.3148V5.79248Z"
            fill="currentColor"
         />
      </svg>
   )
}

export default FlagIcon
